import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { serviceURL } from "@theprelude/core";
import { StatusIcon } from "@theprelude/ds";
import { setPageTitle } from "@/components/app-shell/app-shell";

export const Route = createFileRoute("/status")({
  beforeLoad: () => setPageTitle("Status"),
  component: StatusPage,
});

async function checkProbeDownload() {
  try {
    const response = await fetch(`${serviceURL}/download/install/detect.msi`, {
      method: "GET",
      redirect: "manual",
    });
    return response.type === "opaqueredirect";
  } catch {
    return false;
  }
}

function StatusPage() {
  const { data: serviceUp } = useSuspenseQuery({
    queryKey: ["status", "checkProbeDownload"],
    queryFn: checkProbeDownload,
  });

  return (
    <div className="flex h-screen flex-col items-center justify-center gap-4 text-base">
      {serviceUp ? (
        <>
          <span className="flex items-center gap-1 border-b border-stroke-line pb-4">
            Status: <StatusIcon className="size-4 text-status-green" /> Online
          </span>
          <img className="size-72" src="/images/bird.png" />
          <span className="text-xl">Prelude systems are operational.</span>
        </>
      ) : (
        <>
          <span className="flex items-center gap-1 border-b border-stroke-line pb-4">
            Status: <StatusIcon className="size-4 text-status-red" /> Offline
          </span>
          <img className="size-72" src="/images/jellyfish.png" />
          <span className="text-xl">
            Prelude systems are currently offline.
          </span>
        </>
      )}
    </div>
  );
}
